import { resolveLandingRoute } from "../../config/appsConfig";

/**
 * Cuánto espera el login, como MÁXIMO, a lo que falta tener listo antes de
 * navegar (chunks del destino y, si no vinieron en la respuesta, los accesos).
 * Es un tope de seguridad: en el camino normal no se agota.
 */
export const ACCESS_WAIT_MS = 4000;

/**
 * Chunks de cada destino posible tras el login: el layout y la pantalla de
 * entrada. Son los MISMOS módulos que carga `router/config.tsx` con
 * `React.lazy`, así que el navegador los reutiliza: al navegar ya están
 * descargados y no hay pantalla de carga diferida. Una ruta que no esté aquí
 * simplemente no se precarga.
 */
const CHUNKS_BY_ROUTE: Record<string, Array<() => Promise<unknown>>> = {
  "/apps": [() => import("../apps-hub/AppsHubView")],
  "/map": [
    () => import("../../Layouts/lite/LiteLayout"),
    () => import("../home/components/MapView"),
  ],
  "/admin/units": [
    () => import("../../Layouts/admin/AdminLayout"),
    () => import("../../Layouts/admin/components/sections/UnitsSection"),
  ],
  "/truck-yard/access": [
    () => import("../../Layouts/patio-maniobras/TruckYardLayout"),
    () => import("../patios-maniobras/accessSection/page"),
  ],
  "/inspecciones": [
    () => import("../../Layouts/inspeccion/InspectionsLayout"),
    () => import("../inspecciones/inspectionHistory/inspectionHistorySection"),
  ],
};

/** Baja los chunks de `route`. Nunca rechaza. */
export function preloadRouteChunks(route: string): Promise<unknown> {
  const loaders = CHUNKS_BY_ROUTE[route];
  if (!loaders) return Promise.resolve();
  return Promise.all(loaders.map((load) => load().catch(() => undefined)));
}

/** Precarga el destino por omisión del tenant (para cuando todavía no hay rol). */
export function preloadLandingChunk(): Promise<unknown> {
  return preloadRouteChunks(resolveLandingRoute());
}
